import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Quasar from 'quasar/src/vue-plugin.js';;
import { loadFonts } from "./plugins/webfontloader";
import quasarUserOptions from "./quasar-user-options";
import "@quasar/extras/mdi-v7/mdi-v7.css";
import "@quasar/extras/fontawesome-v6/fontawesome-v6.css";
import MainLoader from "@/components/loader/MainLoader.vue";

// Global Styles
import "@/main.scss";

// Global Method
import { translate } from "@/functions/Utils";

const app = createApp(App);

// Add Global Util Methods
app.config.globalProperties.$utils = {
  translate,
};

// register global components
app.component("MainLoader", MainLoader);

app
  .use(Quasar, quasarUserOptions)
  .use(store)
  .use(router)
  .use(loadFonts)
  .mount("#app");
